<template>
    <div class="uk-width-medium">
        <h3> Reset Password</h3>
       <div class="uk-margin">

            <!-- Login-->
            <div>
                <form class="uk-form-stacked uk-grid-small uk-child-width-1-1" uk-grid>

                    <div>
                        <label class="uk-form-label" for="email">E-mail</label>
                        <div class="uk-form-controls uk-inline uk-width-1-1">
                            <span class="uk-form-icon" uk-icon="icon: mail"></span>
                            <input v-validate="'required|email'" v-model="formData.User.email" name="Email" class="uk-input" id="email" type="email">
                            <span class="help is-danger" v-show="errors.has('Email')">{{ errors.first('Email') }}</span>
                        </div>
                    </div>

                    <div>
                        <button @click.prevent="resetPassword" class="uk-margin uk-button uk-button-primary uk-width-1-1">Send E-mail</button>
                    </div>

                </form>
            </div>

        </div>


    </div>
</template>
<script>
    export default {
        data(){
            return {
                formData: {
                    User: {
                        email: '',
                    }
                }
            }
        },
        methods: {
            resetPassword(){
                this.$validator.validateAll().then(() => {
                    this.$http.post('/users/resetPassword', this.formData).then(response => {
                        // success callback
                        console.log(response)
                    }, response => {
                        // error callback
                    });
                }).catch(() => {

                });
            },
        }
    }
</script>


// WEBPACK FOOTER //
// ResetPassword.vue?70643133